<kt-pv-review [data]="data" [closeDialog]="closeDialog.bind(this)">
  <div class="d-flex m-2">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex">
        <div class="flex-shrink-0 mr-7">
          <div class="symbol symbol-85 mr-3 gl-block">
            <img alt="Pic" [src]="data.patientImage || './assets/media/users/blank.jpg'" />
          </div>
        </div>
        <div class="flex-grow-1">
          <div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
            <div class="mr-3">
              <span
                class="d-flex align-items-center text-dark font-size-h5 font-weight-bold mr-3 gl-block"
                >{{ data.patient_name }} ({{
                  data.patient_dob ? (data.patient_dob | date : 'MM-dd-yyyy') : '-'
                }})</span
              >
              <div class="my-2 d-flex">
                <div>
                  <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                    # {{ data.patient_external_id }}
                  </span>
                </div>
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="mr-3">
                    <div>
                      <div>
                        <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                          Facility: {{ data.facility_name }}
                        </span>
                      </div>
                      <div>
                        <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                          Allergies: {{ data.patient_allergies }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mr-3">
                <button
                  class="ks-mr-2 ks-btn-sm ks-btn-flat-primary"
                  matTooltip="Check all medications"
                  (click)="viewMoreDetail()"
                >
                  View all RXs
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="mr-3">
          <button
            mat-dialog-close
            type="button"
            [matTooltip]="'GLOBAL.CLOSE' | translate"
            class="btn btn-icon btn-light"
          >
            <span
              inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
              class="svg-icon svg-icon-lg"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</kt-pv-review>
